module.exports = __webpack_public_path__ + "img/23.26e504ee.png";